import React from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsHeading } from '../../../SidebarMenu/styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import { DebounceInput } from '../../../../components/DebounceInput';
import { usePpiSettings } from '../hooks/usePpiSettings';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';
import { Slider } from 'antd';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const PpiSection = ({ CurrentDesign, showLabel = true, showSlider = false, customStyles }) => {
  const { t } = useTranslation(NAMESPACES);
  const { ppi, onPpiChange } = usePpiSettings(CurrentDesign);

  const isOpenDesignSelector = React.useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign, updateArtboard] = useArtboardContext(isOpenDesignSelector, 'PpiSection');

  const handleOpenDesign = React.useCallback(() => {
    updateArtboard({
      [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true
    });
  }, [updateArtboard]);

  return (
    <>
      {showLabel && (
        <SettingsHeading complexDesign style={customStyles}>
          {t(DESIGN_AREA_SETTINGS_TAB.PPI_LABEL.key, DESIGN_AREA_SETTINGS_TAB.PPI_LABEL.value)}
        </SettingsHeading>
      )}
      <DebounceInput
        defaultValue={ppi}
        className="manage-setting-input"
        onChange={onPpiChange}
        onClick={isOpenDesign && handleOpenDesign}
        readOnly={isOpenDesign}
        inputType="number"
        min={72}
        max={600}
      />
      {showSlider && (
        <Slider
          min={72}
          max={600}
          value={ppi}
          onChange={onPpiChange}
          style={{ marginTop: 8 }}
        />
      )}
    </>
  );
};


